import React from 'react';   

const HeaderSocials = () => {
    return (
        <div className="home_socials">
            <a href="https://www.instagram.com/jamesmoraless/" className="home_social-link" target="_blank">
            <i class="fa-brands fa-instagram"></i>
            </a>

            <a href="https://www.linkedin.com/in/james-morales-470a161b2/" className="home_social-link" target="_blank">
            <i class="fa-brands fa-linkedin"></i>
            </a>

            <a href="https://www.facebook.com/profile.php?id=100025534603118" className="home_social-link" target="_blank">
            <i class="fa-brands fa-facebook-f"></i>
            </a>

            <a href="https://github.com/jamesmoraless" className="home_social-link" target="_blank">
            <i class="fa-brands fa-github"></i>
            </a>
        </div>
    )
}

export default HeaderSocials